<template>
  <div class="login">
    <div class="login_title">用户登录</div>
    <div class="user"><span class="user_info">用户ID：</span><span class="info_value">{{userData.userId}}</span></div>
    <div class="user"><span class="user_info">GID：</span><span class="info_value">{{userData.gid}}</span></div>
    <div class="user"><span class="user_info">游戏名称：</span><span class="info_value">闲徕平台</span></div>
    <!-- TODO: <div class="user"><span class="user_info">闲徕币数：</span><span class="info_value">{{asset.assetCount}}</span></div> -->
    <!-- TODO: <div class="to_login" @click="changePage">立即充值</div> -->
    <div class="under_login"><span class="to_reg" @click="toLogout">退出当前账号</span></div>
  </div>
</template>

<script>
  import {hex_md5} from '../../utils/md5.js'
  import { mapState } from 'vuex'
  import { mapMutations } from 'vuex'
  export default {
    data(){
      return{
        agree:false,
        appSecret : "b43f0148b81511957b28e011584ea4c73570f700784cdf7891f1c040a353baca",
        clientType:3,
        haslogin:true,
        nicname:''
      }
    },
    mounted:function(){
      var nicname=sessionStorage.getItem('nickname');
      if(nicname&&nicname!=""){
        this.nicname=nicname;
        this.haslogin=false;
      }
      this.getAsset();
    },
    methods:{
      ...mapMutations([
        'logout','setUser','setLoginState','setAsset'
      ]),
      changeAgree(){
        this.agree = !this.agree;
      },
      loginout:function(){
        sessionStorage.removeItem('nickname');
        let url=this.$route.path;
        if(url=='/home'){
          window.location.reload();
        }
        this.$router.push({name:'home'});
      },
      toLogout(){
        this.$confirm('确认退出当前账号？', '退出登录', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.logout();
          this.$router.push({name:'home'});
        }).catch(() => {
        });
      },
      changePage(){
        this.$router.push({name:'charge'});
      },
      open(msg='发送失败') {
        this.$alert(msg, '提示', {
          confirmButtonText: '确定',
          callback: () => {
          }
        });
      },
      //nonce生成*位随机串
      getNonce(len, charSet){
        charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var randomString = '';
        for (var i = 0; i < len; i++) {
          var randomPoz = Math.floor(Math.random() * charSet.length);
          randomString += charSet.substring(randomPoz,randomPoz+1);
        }
        return randomString;
      },
      sign(method,appId,nonce,timestamp,signUrl,appSec){
        var str = method + 'X-QP-AppId:'+appId+'X-QP-Nonce:'+nonce+'X-QP-Timestamp:'+timestamp+signUrl+appSec;
        var newStr = hex_md5(str).toUpperCase();
        return newStr;
      },
      getOS(){
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          return 'ios';
        } else if (/(Android)/i.test(navigator.userAgent)) {
          return 'android';
        }
      },
      getAsset(){
        let ltimestamp = new Date().getTime().toString().substring(0,10);
        let lnonce = new Date().getTime().toString() + this.getNonce(19);
        let url = this.$ajaxUrls.ams + this.userData.gid;
        this.$axios({
          url: url,
          method: 'get',
          headers:{
            'X-QP-AppId':880004,
            'X-Qp-Gid': this.userData.gid,
            'X-QP-UserId': this.userData.userId,
            'X-QP-AppVersion':'1.0.1',
            'X-QP-ResVersion':'1.0.1',
            'X-QP-OS':this.getOS(),
            'X-QP-OSVersion':'',
            'X-QP-ClientType':this.clientType,
            'X-QP-Timestamp': ltimestamp,
            'X-QP-Nonce': lnonce,
            'X-QP-Signature':this.sign('GET',880004,lnonce,ltimestamp,url,this.appSecret),
            'X-QP-Token': this.userData.accessToken,
          }
        }).then((res)=>{
          if(res.data.errCode === 0){
            let result = {};
            res.data.data.forEach(function (e) {
              if(e.assetId ==1002){
                result =e;
              }
            });
            this.setAsset(result)
          }else{
            this.open(res.data.errDesc)
          }
        }).catch((err)=>{
          alert(err)
        })
      }
    },
    computed: mapState([
      'userData','asset'
    ])
  }

</script>

<style lang="scss" scoped>
  @import '../../components/style/mixin';
  .login{width: 338px;height: 378px;border-radius: 8px;background:url("../../images/login_bg.png") no-repeat;padding:45px 36px 0 36px;background-size:338px 378px; }
  .login_title{color: #333333;font-size: 24px;margin-bottom: 20px}
  .user_info{color: #333333;font-size: 14px;display: inline-block;width: 70px;text-align: right}
  .to_login{width:272px;height:53px;background: url("../../images/login_btn.png") no-repeat;background-size: 272px 53px;color: #ffffff;text-align: center;font-size: 14px;padding-top: 13px;cursor: pointer;margin-bottom: 5px}
  .user{margin-bottom: 20px}
  .under_login{width: 260px;text-align: right;font-size: 14px}
  .info_value{color: #666666;font-size: 14px;margin-left: 20px}
  .to_reg{color: #1990FF;cursor: pointer}
</style>
